export default class BarOptions {
    public width:number = 500;
    public height:number = 500;
    public margin = {top: 20, right: 0, bottom: 30, left: 40};
    public data:Promise<any> = Promise.resolve([]);
}
